import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class HoursService {
  constructor() { }

  hours = [
    {
      'shortLabel': 'Open Daily',
      'daysOfWeek': [1, 2, 3, 4, 5],
      'hours': `Sun-Thur: 10AM-7PM Fri-Sat: 10AM-8PM`
    }
    // {
    //   'shortLabel': 'Saturday',
    //   'daysOfWeek': [6],
    //   'hours': '10AM-7PM'
    // },
    // {
    //   'shortLabel': 'Sunday',
    //   'daysOfWeek': [0],
    //   'hours': '10AM-7PM'
    // }
  ];

  getTodaysHours() {
    const today: number = moment().day();
    return this.hours.find((hourObject) => {
      return (hourObject.daysOfWeek.indexOf(today) > -1);
    });
  }

  getAllHours() {
    return this.hours;
  }
}
